import React, { useState, useEffect } from 'react';
import api from "../../api";
import SupplierUserTable from '../../components/UserTable/SupplierUserTable';
import StatCard from '../../components/Profile/StatCard ';
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import Button from "../../components/Button";
import { exportToExcel } from "../../utils/exportToExcel";
import {Link} from "react-router-dom"; // import تابع جدید



export default function SupplierUserManagement() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [newUsersLast7Days, setNewUsersLast7Days] = useState(0);


  useEffect(() => {
    fetchUsers();
  }, []);

const fetchUsers = async () => {
  try {
    setLoading(true);
    const response = await api.get('accounts/admin/users/suppliers/');
    const data = Array.isArray(response.data) ? response.data : [];
    setProfiles(data);

    // ۱️⃣ تعداد کل
    setTotalUsers(data.length);

    // ۲️⃣ تعداد فعال‌ها
    const activeCount = data.filter((p) => p.is_active).length;
    setActiveUsers(activeCount);

    // ۳️⃣ کاربران جدید ۷ روز اخیر
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    const newCount = data.filter((p) => {
      if (!p.date_joined) return false;
      const joinedDate = new Date(p.date_joined);
      return joinedDate >= oneWeekAgo;
    }).length;
    setNewUsersLast7Days(newCount);

  } catch (err) {
    setError('خطا در بارگذاری لیست کاربران');
    console.error(err);
  } finally {
    setLoading(false);
  }
};
 const handleExportExcel = () => {
    if (!profiles.length) {
      alert("داده‌ای برای خروجی وجود ندارد");
      return;
    }
    exportToExcel(profiles, "لیست تأمین کنندگان", {
      headers: {
        full_name: "نام و نام خانوادگی",
        supplier_code: "کد تأمین کننده",
        phone_number: "موبایل",
        province: "استان",
        city: "شهر",
        is_active: "وضعیت",
        date_joined: "تاریخ ثبت‌نام",
      },
    });
  };
  return (
      <div className="p-6">
          {/* خطا */}
          {error && (
              <div className="mb-4 text-red-600">
                  {error}
              </div>
          )}

          {/* کارت‌های آمار */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <StatCard title={'تعداد کل کاربران'} value={toPersianNumbers(totalUsers)}/>
              <StatCard title={'کاربران فعال'} value={toPersianNumbers(activeUsers)}/>
              <StatCard title={'کاربران جدید (۷ روز گذشته)'} value={toPersianNumbers(newUsersLast7Days)}/>
          </div>
          <div className="flex justify-end sm:grid-cols-3 gap-4 mb-6">
              <Link
                  to="/admin-user-register/"
                  state={{role: 'supplier'}}
                  className="px-4 py-2 bg-[#1E3A5F] text-[#FFC107] rounded-md hover:bg-[#2B5388] hover:text-[#D19D00] transition duration-200 whitespace-nowrap"
              >
                  ثبت نام تأمین کننده جدید
              </Link>

              <Button
                  variant={'secondary'}
                  onClick={handleExportExcel}
                  children={'خروجی اکسل'}
              />

          </div>

          <div>
              <SupplierUserTable profiles={profiles} loading={loading}/>
          </div>
      </div>
  );
};